import {
	BottomNavigation,
	BottomNavigationAction,
} from '@mui/material'
import type {
	JSX,
} from 'react'
import {
	useMemo,
} from 'react'
import {
	useLocation,
	useNavigate,
} from 'react-router-dom'

import {
	bottomNavigationConfig,
} from '../../config'

export const BottomNavigationBase = (): JSX.Element => {
	const location = useLocation()
	const navigate = useNavigate()

	const activeTab = useMemo(() => {
		const currentPath = location.pathname

		const exactMatch = bottomNavigationConfig.findIndex(
			(item) => {
				return item.path === currentPath
			},
		)

		if (exactMatch !== -1) {
			return exactMatch
		}

		if (currentPath.startsWith('/rooms/') || currentPath.startsWith('/games/')) {
			const gamesIndex = bottomNavigationConfig.findIndex(
				(item) => {
					return item.key === 'games'
				},
			)

			if (gamesIndex !== -1) {
				return gamesIndex
			}
		}

		if (currentPath.startsWith('/profile/')) {
			const profileIndex = bottomNavigationConfig.findIndex(
				(item) => {
					return item.key === 'profile'
				},
			)

			if (profileIndex !== -1) {
				return profileIndex
			}
		}

		const partialMatchIndex = bottomNavigationConfig.reduce<number>((bestIndex, item, index) => {
			if (!currentPath.startsWith(item.path)) {
				return bestIndex
			}

			if (bestIndex === -1) {
				return index
			}

			const bestPath = bottomNavigationConfig[bestIndex]?.path ?? ''

			return item.path.length > bestPath.length ?
				index :
				bestIndex
		}, -1)

		return partialMatchIndex !== -1 ?
			partialMatchIndex :
			0
	}, [location.pathname])

	const showLabels = useMemo(() => {
		return bottomNavigationConfig.length === 3 ||
			bottomNavigationConfig.every((item) => {
				return item.showLabel === true
			})
	}, [])

	const handleChange = (event: unknown, newValue: number): void => {
		const selectedItem = bottomNavigationConfig[newValue]

		if (selectedItem) {
			navigate(selectedItem.path, {
				replace: true,
			})
		}
	}

	return (
		<BottomNavigation
			value={activeTab}
			onChange={handleChange}
			showLabels={showLabels}
			sx={{
				paddingBottom: 'var(--tg-safe-area-inset-bottom, 0px)',
				height:        'auto',
				minHeight:     56,
			}}
		>
			{bottomNavigationConfig.map((item) => {
				return (
					<BottomNavigationAction
						key={item.key}
						icon={item.icon}
						label={item.label}
					/>
				)
			})}
		</BottomNavigation>
	)
}
